import * as actionTypes from "./DemandType";

const INITIAL_STATE = {
  dmdList: [],
  dmdTaskList: [],
  dmdStageHistory: [],
  dmd: null,
  dmdStagesList: [],
  dmdTypeList: [],
  dmdStatusList: [],
  dmdComments: [],
  dmdQuoteInvoice: [],
  dmdDeliverablesList: [],
  dmdDeliverables: null,
  dmdDeliverablesByType: [],
  stagewiseCount: [],
  statuswiseCount: [],
  taskList: [],
  taskDeliverables: [],
  commentsById: [],
  demandByDmdId: null,
  demandOrderList: [],
  invoiceRequestList: [],
  deliveryPendingList: [],
  demandSummary: {
    totalDemand: 0,
    ongoingDemand: 0,
    hold: 0,
    completedThisMonth: 0,
    newDemandThisMonth: 0,
    totalDemandValues: 0,
    totalDemandValueCurrentMonth: 0,
    totalInvoiceValueCurrentMonth:0
  },
};

const DemandReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.SET_DMD_LIST:
      return { ...state, dmdList: action.payload.list };
    case actionTypes.SET_DMD_TASK_LIST:
      return { ...state, dmdTaskList: action.payload.list };
    case actionTypes.SET_DMD_STAGE_HISTORY:
      return { ...state, dmdStageHistory: action.payload.list };
    case actionTypes.SET_DMD:
      return { ...state, dmd: action.payload.data };
    case actionTypes.SET_DMD_STAGES_LIST:
      return { ...state, dmdStagesList: action.payload.list };
    case actionTypes.SET_DMD_TYPE_LIST:
      return { ...state, dmdTypeList: action.payload.list };
    case actionTypes.SET_DMD_STATUS_LIST:
      return { ...state, dmdStatusList: action.payload.list };
    case actionTypes.SET_DMD_COMMENTS:
      return { ...state, dmdComments: action.payload.list };
    case actionTypes.SET_DMD_QUOTE_INVOICE:
      return { ...state, dmdQuoteInvoice: action.payload.list };
    case actionTypes.SET_DMD_DELIVERABLES_LIST:
      return { ...state, dmdDeliverablesList: action.payload.list };
    case actionTypes.SET_DMD_DELIVERABLES:
      return { ...state, dmdDeliverables: action.payload.data };
    case actionTypes.SET_STAGEWISE_COUNT:
      return { ...state, stagewiseCount: action.payload.list };
    case actionTypes.SET_STATUSWISE_COUNT:
      return { ...state, statuswiseCount: action.payload.list };
    case actionTypes.SET_TASK_LIST:
      return { ...state, taskList: action.payload.list };
    case actionTypes.SET_TASK_DELIVERABLES:
      return { ...state, taskDeliverables: action.payload.list };
    case actionTypes.SET_COMMENTS_BY_ID:
      return { ...state, commentsById: action.payload.list };
    case actionTypes.SET_DEMAND_BY_DMDID:
      return { ...state, demandByDmdId: action.payload.data };
    case actionTypes.SET_DMD_ORDER_LIST:
      return { ...state, demandOrderList: action.payload.list };
    case actionTypes.SET_INVOICE_REQUEST_LIST:
      return { ...state, invoiceRequestList: action.payload.list };
    case actionTypes.SET_DMD_DELIVERY_PENDING_LIST:
      return { ...state, deliveryPendingList: action.payload.list };
    case actionTypes.SET_DMD_DELIVERABLES_BY_TYPE:
      return { ...state, dmdDeliverablesByType: action.payload.list };
    case actionTypes.SET_DEMAND_SUMMARY:
      return { ...state, demandSummary: action.payload };
    case actionTypes.CLEAR_DMD:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default DemandReducer;